<!--
 * @Description: 无缝轮播图
 * @Date: 2019-10-29 10:21:46
 * @LastEditors: Ji Yinghao
 * @LastEditTime: 2019-10-31 16:41:39
 -->

<template>
  <v-row justify="center">
    <v-dialog v-model="dialog" max-width="500px">
      <v-card>
        <!-- <v-card-title>
          <span> 大图预览 </span>
          <v-spacer></v-spacer>
          <v-menu bottom left>
            <template v-slot:activator="{ on }">
              <v-btn icon v-on="on" @click="()=>{dialog = false}">
                <v-icon>close</v-icon>
              </v-btn>
            </template>
          </v-menu>
        </v-card-title> -->
        <v-card-text class="black--text" style="padding-top: 20px;" >
          <v-carousel
                    height="700"
                    delimiter-icon="mdi-minus"
                    >
                      <template v-for="(color, i) in content">
                        <v-carousel-item :key="i" v-if="color.thumb_url !== ''">
                          <v-sheet height="100%" tile>
                            <v-row class="fill-height" align="center" justify="center" >
                              <div class="display-3" style="width:100%;text-align: center;" >
                                <img :src="color.url" alt="" srcset="" style="max-height:700px;" @click="Image( color.url )">
                              </div>
                            </v-row>
                          </v-sheet>
                        </v-carousel-item>
                      </template>
                  </v-carousel>
        </v-card-text>
        <!-- <v-card-actions>
            gradient="to bottom, rgba(0,0,0,.1), rgba(0,0,0,.5)"
          <v-btn color="primary" text @click="dialog = false">Close</v-btn>
        </v-card-actions> -->
      </v-card>
    </v-dialog>
  </v-row>
</template>

<script>
export default {
  data() {
    return {
      dialog: false,
      content: [],
      index: 0
    };
  },
  methods: {
    info(state, image, index) {
      this.dialog = state;
      this.content = image;
      this.index = index
    },
    /* 原图 */ 
    Image( img ){
      if( img == '' ){ return }
      window.open(img,'newwindow', `height=600, width=800, top=${ document.body.clientHeight/2 - 200 }, left=${ document.body.clientWidth/2 - 400 }, toolbar=no, menubar=no, scrollbars=no, resizable=no,location=no, status=no`);
    }
  }
};
</script>